/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

// 获取结算单列表
exports.getSettleProofPagedList = function (data, callback) {// 获取结算单列表
    api.post('/settle/proof/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取结算单信息
exports.getSettleProof = function (id, callback) {// 获取结算单信息
    api.get('/settle/proof/get')
    .params({
        id: id
    })
    .done(callback)
    .go();
};
// 服务工单生成结算单
exports.saveSettleProofByServcWorkVoucher = function (data, callback) {
    api.post('/settle/servc/work/settle/proof/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单开票并生成结算单
exports.saveInvoiceAndSettleProofByServcWork = function (data, callback) {
    api.post('/settle/proof/and/invoice/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 设置结算标签
exports.updateSettleTag = function (data, callback) {
    api.post('/settle/servc/settle/tag/update/do')
    .data(data)
    .done(callback)
    .go();
};
// ==================== 结算支付项 ==================
// 获取结算支付项列表
exports.getSettlePayItemList = function (data, callback) {
    api.post('/settle/pay/item/list/get')
    .data(data)
    .done(callback)
    .go();
};
// ==================== 结算发票项列表 ==================
// 结算关联发票
exports.doSettleProofRelInvoiceVoucher = function (data, callback) {
    api.post('/settle/proof/rel/invoice/voucher/do')
    .data(data)
    .done(callback)
    .go();
};
// 结算单移除发票
exports.updateSettleInvoiceItemForRemove = function (data, callback) {
    api.post('/settle/proof/invoice/item/for/remove')
    .data(data)
    .done(callback)
    .go();
};
exports.getSettleInvoiceItemList = function (data, callback) {// 结算发票项列表
    api.post('/settle/proof/invoice/items/get')
    .data(data)
    .done(callback)
    .go()
};
// 结算发票项分页列表
exports.getSettleInvoiceItemPageList = function (data, callback) {// 结算发票项分页列表
    api.post('/settle/proof/invoice/item/list/get')
    .data(data)
    .done(callback)
    .go()
};
// 结算发票项作废
exports.updateSettleInvoiceItemForInvalid = function (data, callback) {
    api.post('/settle/proof/invoice/item/for/invalid')
    .data(data)
    .done(callback)
    .go();
};
// 获取结算单已申请开票金额
exports.getSettleInvoiceAmountAble = function (settleProofId/* 结算单id */, callback) {// 结算发票项分页列表
    api.get('/settle/proof/invoice/amountAble/get')
    .params({
        settleProofId: settleProofId
    })
    .done(callback)
    .go()
};
//
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/settle.js
// module id = 86
// module chunks = 1